// Bank logo
import banrisulLogo from '../../../image/bank-logo/banrisul-logo.png';
import bancoBrasilLogo from '../../../image/bank-logo/banco-brasil-logo.png';
import bradescoLogo from '../../../image/bank-logo/bradesco-logo.png';
import c6Logo from '../../../image/bank-logo/c6-logo.png';
import caixaLogo from '../../../image/bank-logo/caixa-logo.png';
import interLogo from '../../../image/bank-logo/inter-logo.png';
import itauLogo from '../../../image/bank-logo/itau-logo.png';
import nubankLogo from '../../../image/bank-logo/nubank-logo.png';
import santanderLogo from '../../../image/bank-logo/santander-logo.png';

const BANK_LIST = [
  {
    active: true,
    code: '1',
    name: '001 - Banco do Brasil',
    logo: bancoBrasilLogo,
  },
  {
    active: true,
    code: '104',
    name: '104 - Caixa Econômica Federal',
    logo: caixaLogo,
  },
  {
    active: true,
    code: '237',
    name: '237 - Bradesco',
    logo: bradescoLogo,
  },
  {
    active: true,
    code: '33',
    name: '033 - Santander',
    logo: santanderLogo,
  },
  {
    active: true,
    code: '341',
    name: '341 - Itaú',
    logo: itauLogo,
  },
  {
    active: true,
    code: '41',
    name: '041 - Banrisul',
    logo: banrisulLogo,
  },
  {
    active: true,
    code: '260',
    name: '260 - Nubank',
    logo: nubankLogo,
  },
  {
    active: true,
    code: '077',
    name: '077 - Banco Inter',
    logo: interLogo,
  },
  {
    active: true,
    code: '336',
    name: '336 - C6 Bank',
    logo: c6Logo,
  },
];

/**
 * Get bank by code.
 * @param {string} bankCode - The bank code.
 */
const getBankByCode = (bankCode) => {
  const bankList = BANK_LIST.filter((bank) => bank.code === `${bankCode}`);
  return bankList?.length > 0 ? bankList[0] : null;
};

export { BANK_LIST, getBankByCode };
